<template>
  <div>
    {{ abreviation }}
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-icon color="grey" dark v-bind="attrs" v-on="on">
          mdi-message-question
        </v-icon>
      </template>
      <span>{{ intitule }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    abreviation: {
      type: String,
      required: true,
    },
  },
  computed: {
    intitule() {
      switch (this.abreviation.toLowerCase()) {
        case "ui":
          return "Unité intègre: Plus petite unité d'emploi non divisible";
        case "cdt":
        case "ucd":
          return "Unité de commande commerciale";
        case "qml":
          return "Quantité Minimale de Livraison";
      }
      return "";
    },
  },
};
</script>

<style></style>
